import { ALL_LOG_LEVELS } from "./constants";

const getLogLevels = () =>
  ALL_LOG_LEVELS.reduce(
    (logLevels, level, index) => ({
      ...logLevels,
      [level]: index
    }),
    {}
  );

export default getLogLevels;
